import 'boxicons'

import './menu.js'
import './modules/slider.js'
import './modules/logos.js'
import './modules/avis.js'
import './modules/alert.js'
import './modules/map.js'
import './modules/filters.js'
import './video.js'
import './influenceurs.js'
import './single-influenceur.js'



// WEBPACK FOOTER //
// ./scripts/main.js